import { twMerge } from "tailwind-merge";
import PropTypes from "prop-types";
import React from "react";

function MaxicareLogo({ className, ...props }) {
  const c = twMerge("w-58 h-38", className);

  return (
    <div>
      <img
        src={require("../assets/ic_maxicare.png")}
        alt="logo"
        {...props}
        className={c}
      />
    </div>
  );
}

MaxicareLogo.propTypes = {
  className: PropTypes.any,
};
export default MaxicareLogo;
